// extracted by mini-css-extract-plugin
export default {"inner":"LeadDetails_inner__7IQWj"};